<template>
  <div>
    <!-- <b-list-group>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
            Số tiền vay
            <span style="font-size: 18px; font-weight: 700;">{{sliderValue | toThousandFilter }}đ</span>
        </b-list-group-item>
    </b-list-group> -->

    <div class="grid grid-cols-2 font-bold mt-2">
        <div>
            Số tiền vay
        </div>
        <div class="text-right">
            {{sliderValue | toThousandFilter }}đ
        </div>
    </div>

    <range-slider class="slider" :min="min" @change="updateValue"  :max="max" :step="step" v-model="sliderValue">
    </range-slider>

    <div class="grid grid-cols-2 text-gray-400">
        <div>
            {{min | toMillion }}
        </div>
        <div class="text-right">
            {{max | toMillion }}
        </div>
    </div>

    <!-- <b-list-group>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
            {{min | toMillion }}
            <span >{{max | toMillion }}</span>
        </b-list-group-item>
    </b-list-group> -->
  </div>
</template>

<script>
import RangeSlider from "vue-range-slider";
import "vue-range-slider/dist/vue-range-slider.css";

export default {
  name: "CustomRangeSlider",
  props: {
    msg: String,
    color: String,
    min: Number,
    max: Number,
    amount: Number,
    step: Number,
    onUpdate: Function
  },
  data() {
    return {
      sliderValue: this.amount,
    };
  },
  methods: {
    updateValue(){
      this.onUpdate && this.onUpdate(this.sliderValue)
    }
  },
  components: {
    RangeSlider
  },
  created(){
    //this.sliderValue = this.amount
  },
  watch: {
    // whenever question changes, this function will run
    // sliderValue(amount) {
    //   this.onUpdate && this.onUpdate(this.sliderValue)
    // }
  },
};
</script>

<style>
.slider {
  width: 100%;
  margin-top: 10px;
}

.slider .range-slider-rail {
  height: 6px;
  background-color: #EBECED;
  border-radius: 5px;
}

.slider .range-slider-fill {
  height: 5px;
  margin: 0 0px;
  background-color: v-bind(color);
}

.slider .range-slider-knob {
  height: 17px;
  width: 17px;
  color: #fff;
  background-color: v-bind(color);
  border: 0;
  box-shadow: 0 0 0 3px rgb(0 111 138 / 0.2);
}

.slider .knobby {
  position: relative;
}

.slider .knobby svg {
  width: 50px;
  height: 50px;
  position: absolute;
  top: -65px;
  left: -14px;
}

.slider .knobby svg text {
  font-size: 5px;
  font-weight: bold;
}
</style> 
